/**
 * Function permettant de valider le formulaire " courseForm "
 * @param  {Object} values Valeur des champs présent dans le formulaire
 * @return {Object}        Object contenant toute les erreurs
 */
const validate = values => {
  const errors = {};
  if (!values.street) {
    errors.street = 'Champ requis';
  }
  if (!values.city) {
    errors.city = 'Champ requis';
  }
  if (!values.postalCode) {
    errors.postalCode = 'Champ requis';
  }
  return errors;
};

export default validate;
